import { companiesService } from '@/features/companies';
import { subscriptionsService, type Subscription, type SubscriptionOverview } from '@/features/subscriptions';

export interface DashboardStats extends SubscriptionOverview {
  totalCompanies: number;
}
export interface DashboardData {
  stats: DashboardStats;
  recentSubscriptions: Subscription[];
}
export const dashboardService = {
  async loadStats(): Promise<DashboardData> {
    const [companies, overview, recent] = await Promise.all([
      companiesService.list({ page: 1, limit: 1 }),
      subscriptionsService.overview(),
      subscriptionsService.list({ page: 1, limit: 5 }),
    ]);
    return {
      stats: { ...overview, totalCompanies: companies.pagination.total },
      recentSubscriptions: recent.data,
    };
  },
};
